import { Skeleton } from '@mui/material';

export function FormulationFilterSkeleton() {
  return <Skeleton variant="rounded" height={40} />;
}

export default FormulationFilterSkeleton;
